import React, { useState, useEffect } from "react";
import DailyReportTable from "./child/DailyReportTable";
import axios from "axios";
import { useSelector } from "react-redux";
import DailyReportSelectOptions from "./child/DailyReportSelectOptions";
import DefaultRadioTwo from "./child/DefaultRadioTwo";
// import AxiosInstance from "../utils/AxiosInstance";
import { set } from "date-fns";
import DefaultRadioTwoTest from "./child/DefaultRadioTwoTest";
import DailyReportTableTest from "./child/DailyReportTableTest";
import UnitCountEight from "./child/UnitCountEight";
import DefaultRadioTwelve from "./child/DefaultRadioTwelve";
import DailyReportTableTwelve from "./child/DailyReportTableTwelve";
import { useConfig } from "../utils/ConfigContext.jsx";
import {createAxiosInstance} from "../utils/AxiosInstance.jsx";


const mainHeader = [
  { key: 'srNo', label: '#', rowSpan: true },
  { key: 'Hospital_Name', label: 'Center', rowSpan: true },
  { key: 'Assistant_Doctor', label: 'Doctor', rowSpan: true },
  { key: 'Report_Month', label: 'Month', rowSpan: true },
  { key: 'Total_Appointments', label: 'Appointments', rowSpan: true },
  { key: 'Advised_EECP', label: 'Advised(SNB)', rowSpan: true },
  { key: 'Advised_Detox', label: 'Advised(SDT)', rowSpan: true },
  { key: 'Booked_EECP', label: 'Booked(SNB)', rowSpan: true },
  { key: 'Booked_Detox', label: 'Booked(SDT)', rowSpan: true },
  { key: 'Total_Patients', label: 'Patients', rowSpan: true },
  { key: 'Total_Package_Price', label: 'Package Price', rowSpan: true },
  { key: 'Received_Amount', label: 'Received Amount', rowSpan: true },
  { key: 'Total_Discount', label: 'Discount', rowSpan: true }
];
// now i have to save data that show in the table 
const responseData = [
  {
    srNo: 1,
    Hospital_Name: " Karnataka Hebbal ",
    Assistant_Doctor: "Shamilee -",
    Report_Month: "May 2025",
    Total_Appointments: 5,
    Advised_EECP: 3,
    Advised_Detox: 3,
    Booked_EECP: 1,
    Booked_Detox: 1,
    Total_Patients: 1,
    Total_Package_Price: 90000,
    Received_Amount: 27000,
    Total_Discount: 0
  },
  {
    srNo: 2,
    Hospital_Name: " Uttarakhand Dehradun Shivpuri",
    Assistant_Doctor: "Pawan Jaiswal",
    Report_Month: "May 2025",
    Total_Appointments: 85,
    Advised_EECP: 33,
    Advised_Detox: 30,
    Booked_EECP: 19,
    Booked_Detox: 21,
    Total_Patients: 24,
    Total_Package_Price: 4760000,
    Received_Amount: 2407500,
    Total_Discount: 0
  },
  {
    srNo: 3,
    Hospital_Name: " Uttarakhand Dehradun Mohitnagar",
    Assistant_Doctor: "Masood Alam",
    Report_Month: "May 2025",
    Total_Appointments: 28,
    Advised_EECP: 14,
    Advised_Detox: 13,
    Booked_EECP: 4,
    Booked_Detox: 2,
    Total_Patients: 4,
    Total_Package_Price: 480000,
    Received_Amount: 147000,
    Total_Discount: 0
  },
  {
    srNo: 4,
    Hospital_Name: " Mumbai Dadar",
    Assistant_Doctor: "Shaukat -",
    Report_Month: "May 2025",
    Total_Appointments: 6,
    Advised_EECP: 4,
    Advised_Detox: 4,
    Booked_EECP: 1,
    Booked_Detox: 1,
    Total_Patients: 1,
    Total_Package_Price: 140000,
    Received_Amount: 70000,
    Total_Discount: 0
  },
  {
    srNo: 5,
    Hospital_Name: " Tamil Nadu Kilpauk",
    Assistant_Doctor: "Radhika -",
    Report_Month: "May 2025",
    Total_Appointments: 5,
    Advised_EECP: 5,
    Advised_Detox: 5,
    Booked_EECP: 4,
    Booked_Detox: 2,
    Total_Patients: 4,
    Total_Package_Price: 480000,
    Received_Amount: 59002,
    Total_Discount: 0
  },
  {
    srNo: 6,
    Hospital_Name: " Karnataka Kundalahalli",
    Assistant_Doctor: "Sindhu R",
    Report_Month: "May 2025",
    Total_Appointments: 18,
    Advised_EECP: 4,
    Advised_Detox: 1,
    Booked_EECP: 1,
    Booked_Detox: 0,
    Total_Patients: 1,
    Total_Package_Price: 50000,
    Received_Amount: 5000,
    Total_Discount: 0
  },
  {
    srNo: 7,
    Hospital_Name: " Karnataka Banasankari",
    Assistant_Doctor: "Bhavani  Yaradi",
    Report_Month: "May 2025",
    Total_Appointments: 9,
    Advised_EECP: 0,
    Advised_Detox: 0,
    Booked_EECP: 0,
    Booked_Detox: 2,
    Total_Patients: 2,
    Total_Package_Price: 120000,
    Received_Amount: 14000,
    Total_Discount: 5000
  },
  {
    srNo: 8,
    Hospital_Name: " Mumbai Tardeo ",
    Assistant_Doctor: "Payal ghatvisave",
    Report_Month: "May 2025",
    Total_Appointments: 2,
    Advised_EECP: 2,
    Advised_Detox: 2,
    Booked_EECP: 0,
    Booked_Detox: 0,
    Total_Patients: 0,
    Total_Package_Price: 0,
    Received_Amount: 67500,
    Total_Discount: 0
  },
  {
    srNo: 9,
    Hospital_Name: " Mumbai Andheri",
    Assistant_Doctor: "Asif -",
    Report_Month: "May 2025",
    Total_Appointments: 2,
    Advised_EECP: 2,
    Advised_Detox: 2,
    Booked_EECP: 2,
    Booked_Detox: 2,
    Total_Patients: 2,
    Total_Package_Price: 242500,
    Received_Amount: 169500,
    Total_Discount: 0
  },
  {
    srNo: 10,
    Hospital_Name: " Uttarakhand Haridwar",
    Assistant_Doctor: "Pawan  Sharma",
    Report_Month: "May 2025",
    Total_Appointments: 3,
    Advised_EECP: 2,
    Advised_Detox: 2,
    Booked_EECP: 1,
    Booked_Detox: 1,
    Total_Patients: 1,
    Total_Package_Price: 140000,
    Received_Amount: 75000,
    Total_Discount: 5000
  }
];

const DashBoardLayerEightTest = () => {
  const { API_BASE_URL } = useConfig(); // ✅ from context
  const AxiosInstance = createAxiosInstance(API_BASE_URL);
  const [ selectedStateType, setSelectedStateType ] = useState([]);
  const [ selectedColumnType, setSelectedColumnType ] = useState([ 'lead' ]);

  useEffect(() => {
    getStateValue([
      null,
      true,
      false,
      false
    ])
  }, []);

  const getStateValue = (getStateValueArray) => {
    let checkedStateValueArray = [];
    getStateValueArray.map((item, key) => {
      if (item) {
        checkedStateValueArray.push(key);
      }
    })
    AxiosInstance.post("/reports/state-center-typewise", { ht_ids: checkedStateValueArray })
      .then((response) => {
        console.log("Response from server:", response.data);

        setSelectedStateType(response.data.map((item, key) => ({
          id: key + '_' + item.hm_state.replace(/ /g, "_").trim(),
          name: item.hm_state,
          centerType: item.centertype_ids,
          report_count: item.report_count, // Ensure this field is present
        })));
      }).catch((error) => {
        console.error("Error fetching data:", error);
      })

  };
  const getColumnValue = (getColumnValueArray) => {

    let checkedColumnValueArray = [];
    Object.entries(getColumnValueArray).forEach(([ key, value ]) => {
      if (value) {
        console.log(key);
        checkedColumnValueArray.push(key);
      }
    });
    console.log(checkedColumnValueArray);
    setSelectedColumnType(checkedColumnValueArray);

  };
  console.log(selectedStateType)
  const [ openPanels, setOpenPanels ] = useState({});


  const togglePanel = (id) => {
    setOpenPanels((prev) => ({
      ...prev,
      [ id ]: !prev[ id ],
    }));
  };
  return (
    <>

      <DefaultRadioTwelve getStateValue={getStateValue} getColumnValue={getColumnValue} />
      <UnitCountEight />
      <div className="accordion" id="accordionPanelsStayOpenExample">
        <div className="accordion-item">
          <h2 className="accordion-header" id="panelsStayOpen-headingOne"></h2>

          <div className="accordion-collapse collapse show">
            <div className="accordion-body">
              <div className="accordion" id="accordionExample">
                {selectedStateType.map(({ id, name, centerType, report_count }) => {
                  const isOpen = openPanels[ id ];
                  const isDisabled = report_count === 0;

                  return (
                    <div className={`accordion-item bg_sky ${isDisabled ? 'disabled-section' : ''}`} key={id}>
                      <h2 className="accordion-header position-relative" id={`heading_${id}`}>
                        <button
                          className={`accordion-button ${isOpen ? "" : "collapsed"}`}
                          type="button"
                          data-bs-toggle={isDisabled ? "" : "collapse"}
                          data-bs-target={isDisabled ? "" : `#collapse_${id}`}
                          aria-expanded={isOpen ?? false}
                          aria-controls={`collapse_${id}`}
                          onClick={() => {
                            if (!isDisabled) togglePanel(id);
                          }}
                          disabled={isDisabled}
                        >
                          {name}
                        </button>
                        {/* Overlay message if report_count === 0 */}
                        {isDisabled && (
                          <div className="data-not-found-overlay">
                            Data not found
                          </div>
                        )}
                      </h2>

                      <div
                        id={`collapse_${id}`}
                        className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
                        aria-labelledby={`heading_${id}`}
                        data-bs-parent={false} // This allows multiple to stay open
                      >
                        {isOpen && (
                          <div className="accordion-body">
                            <div className="row gy-4">
                              <div className="col-xxxl-12">
                                <div className="row gy-4" style={{ padding: "15px" }}>
                                  <DailyReportTableTwelve
                                    id={id}
                                    mainHeader={mainHeader}
                                    statename={name}
                                    centerType={centerType}
                                    selectedColumnType={selectedColumnType}
                                    responseData={responseData}
                                  />
                                </div>
                              </div>
                            </div>

                          </div>
                        )}

                      </div>
                    </div>
                  );
                })}
              </div>

            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default DashBoardLayerEightTest;
